var _circle, _circle2, _circle3, _circle4, _ellipse, _path, _path2, _rect, _path3, _path4, _path5, _circle5, _circle6, _circle7, _path6, _rect2, _path7, _path8, _path9, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 196,
    viewBox: "0 0 204 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0499,
    cy: 36.541,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.976,
    cy: 54.2022,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.456,
    cy: 63.2716,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 199.069,
    cy: 93.3435,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.3071,
    cy: 95.3723,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.565 95.3723C166.565 132.18 136.461 162.034 99.3071 162.034C62.1531 162.034 32.0488 132.18 32.0488 95.3723C32.0488 58.5644 62.1531 28.7107 99.3071 28.7107C136.461 28.7107 166.565 58.5644 166.565 95.3723Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.596 63.1257L125.924 62.2897C125.924 66.7048 122.858 68.2544 121.325 68.4773C118.844 68.979 113.214 70.0828 110.538 70.4841C107.862 70.8855 106.636 73.1042 106.357 74.1633V82.9432H160.374V76.9227V74.1633L159.789 72.1565L159.037 71.3203L157.364 70.4841L155.608 69.9824L147.748 68.8954L144.571 68.4773L142.564 67.3067L141.895 65.8015L141.059 63.962L140.557 62.2897L138.717 63.1257L135.624 63.962H133.366H130.857L127.596 63.1257Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.111,
    y: 28.7107,
    width: 27.8758,
    height: 35.1553,
    rx: 13.9379,
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.965 68.3878C122.4 67.9244 123.751 67.6931 124.833 65.5707C125.262 64.7299 125.757 63.7563 125.757 62.2896",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140.223 62.2897C140.223 63.7563 140.718 64.7299 141.147 65.5707C142.23 67.6932 143.58 67.9245 147.016 68.3878L155.114 70.0154C158.284 70.6901 159.336 72.3723 159.268 75.3567C159.201 78.341 159.24 81.2349 159.268 82.3088H106.619V75.3567",
    stroke: "#787E8C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.914 62.7499L110.709 63.1256L110.839 63.5339C110.864 63.6141 110.892 63.7015 110.922 63.7953C111.176 64.5853 111.574 65.8262 111.842 67.0167C111.993 67.685 112.092 68.2933 112.11 68.7704C112.119 69.0085 112.106 69.1816 112.083 69.2967C112.078 69.3224 112.074 69.3423 112.069 69.3572C112.021 69.3805 111.888 69.433 111.597 69.456C111.193 69.4879 110.661 69.4482 110.054 69.3485C108.846 69.1504 107.531 68.7482 106.745 68.4574L106.241 68.2707L105.807 68.589C102.932 70.698 99.4122 71.9373 95.6089 71.9373C85.9432 71.9373 78.0684 63.9121 78.0684 53.9635C78.0684 44.015 85.9432 35.9897 95.6089 35.9897C105.275 35.9897 113.149 44.015 113.149 53.9635C113.149 57.1577 112.337 60.1537 110.914 62.7499Z",
    fill: "white",
    stroke: "#787E8C",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.9899,
    cy: 53.9637,
    r: 1.7751,
    fill: "#787E8C"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.6091,
    cy: 53.9637,
    r: 1.7751,
    fill: "#787E8C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.931,
    cy: 53.9637,
    r: 1.7751,
    fill: "#787E8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0514 127.152L63.0756 126.164C63.0756 131.381 59.4523 133.212 57.6406 133.475C54.7095 134.068 48.0567 135.372 44.8949 135.846C41.7332 136.321 40.2843 138.942 39.9551 140.194V150.568H103.782V143.454V140.194L103.091 137.823L102.202 136.834L100.225 135.846L98.1505 135.254L88.863 133.969L85.1084 133.475L82.7371 132.092L81.9467 130.313L80.9587 128.14L80.3659 126.164L78.1922 127.152L74.5364 128.14H71.8687H68.9046L65.0514 127.152Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 1,
    width: 34.3035,
    height: 43.1492,
    rx: 17.1517,
    transform: "matrix(-1 0 0 1 87.8945 84.3677)",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8574 133.796C84.6831 133.233 83.0421 132.952 81.7262 130.373C81.2049 129.351 80.6034 128.168 80.6034 126.386",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0254 126.386C63.0254 128.168 62.424 129.351 61.9027 130.373C60.5868 132.952 58.9457 133.233 54.7715 133.796L44.9307 135.774C41.0782 136.594 39.8001 138.638 39.8825 142.264C39.9649 145.891 39.9168 149.407 39.8825 150.712H103.86V142.264",
    stroke: "#194590",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4529 127.049L98.6587 127.425L98.5288 127.833C98.4978 127.93 98.4639 128.036 98.4273 128.15C98.1196 129.109 97.6329 130.626 97.3045 132.083C97.1202 132.9 96.9964 133.654 96.9739 134.253C96.9627 134.552 96.9782 134.78 97.0098 134.942C97.0316 135.054 97.0553 135.104 97.062 135.117C97.0976 135.149 97.2755 135.268 97.795 135.309C98.3106 135.35 98.9762 135.298 99.722 135.176C101.207 134.932 102.818 134.439 103.782 134.083L104.287 133.896L104.721 134.214C108.25 136.803 112.571 138.325 117.24 138.325C129.109 138.325 138.77 128.472 138.77 116.269C138.77 104.066 129.109 94.2128 117.24 94.2128C105.371 94.2128 95.7106 104.066 95.7106 116.269C95.7106 120.187 96.7071 123.863 98.4529 127.049Z",
    fill: "white",
    stroke: "#194590",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.15701,
    cy: 2.15701,
    r: 2.15701,
    transform: "matrix(-1 0 0 1 128.654 114.112)",
    fill: "#194590"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.15701,
    cy: 2.15701,
    r: 2.15701,
    transform: "matrix(-1 0 0 1 119.398 114.112)",
    fill: "#194590"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.15701,
    cy: 2.15701,
    r: 2.15701,
    transform: "matrix(-1 0 0 1 110.5 114.112)",
    fill: "#194590"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.6144,
    cy: 64.7038,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1671,
    cy: 176.876,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.671,
    cy: 187.855,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.95,
    cy: 174.967,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 122.697,
    cy: 172.103,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 127.471,
    cy: 185.946,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 108.853,
    cy: 191.674,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 173.293,
    cy: 161.841,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 188.568,
    cy: 133.439,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 179.26,
    cy: 118.642,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 183.08,
    cy: 88.5701,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 190.955,
    cy: 72.341,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 185.467,
    cy: 35.825,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 72.8164,
    cy: 194.06,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 38.6855,
    cy: 189.287,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 43.459,
    cy: 180.934,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 12.4336,
    cy: 142.748,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 19.3554,
    cy: 127.95,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 1.69333,
    cy: 89.5247,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 20.5488,
    cy: 59.6919,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 24.3672,
    cy: 17.448,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 60.8828,
    cy: 1.21872,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 107.422,
    cy: 19.8347,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.437,
    cy: 13.8679,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M169.476 145.373C168.421 145.373 167.566 144.518 167.566 143.464C167.566 142.409 168.421 141.554 169.476 141.554",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51172 112.675C6.56621 112.675 7.42104 111.821 7.42104 110.766C7.42104 109.712 6.56621 108.857 5.51172 108.857",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5312 17.4482C74.5857 17.4482 75.4406 16.5933 75.4406 15.5388C75.4406 14.4843 74.5857 13.6295 73.5312 13.6295",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.832 10.7653C118.778 10.7653 117.923 11.6202 117.923 12.6747C117.923 13.7292 118.778 14.584 119.832 14.584",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33008 161.96H15.2967M25.3207 150.862V152.413M37.0153 161.96H38.5666M25.3207 171.506V173.296M25.3207 175.683V182.008M20.9053 161.96C23.8887 161.96 25.44 157.664 25.44 157.664C25.44 157.664 25.9173 161.96 29.736 161.96C28.0176 161.96 25.5593 163.511 25.3207 166.614C25.3207 166.614 25.0428 164.074 24.1273 163.153C23.363 162.384 20.9053 161.96 20.9053 161.96Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.709 25.0851L171.742 25.0851M161.599 40.837L161.718 34.6317M150.024 25.0851L148.472 25.0851M161.599 15.7771L161.599 3.60524M166.134 25.0851C163.15 25.0851 161.599 29.3811 161.599 29.3811C161.599 29.3811 161.122 25.0851 157.303 25.0851C159.021 25.0851 161.48 23.5338 161.718 20.4311C161.718 20.4311 161.996 22.9713 162.912 23.8918C163.676 24.6603 166.134 25.0851 166.134 25.0851Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.cf90c8cc8d9e0901d3decb28779050a4.svg";
export { ForwardRef as ReactComponent };